import React, { useRef } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  lifecycle,
  withHandlers,
  withState
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
// import Autocomplete from '@material-ui/lab/Autocomplete';
import Typography from '@material-ui/core/Typography';
import {
  FormControlLabel,
  Modal,
  Radio,
  RadioGroup,
  TableBody,
  TableCell,
  TableRow
} from '@material-ui/core';
import ReactSelectMaterialUi from 'react-select-material-ui';
import { sendLogin } from '../../auth/Auth';
import {
  getMenuImageSample,
  GET_MENU_IMAGE_SUCCESS
} from '../../actions/GochiMenus';
// import { getShops } from '../../actions/Shop';
import { getOptionGroups, getOptionShops } from '../../actions/Options';
import RequiredButton from '../../components/atoms/RequiredButton';
import usageTypes from '../../constants/UsageType';
import ValidationText from '../../components/atoms/ValidationText';
import CancelButton from '../../components/atoms/CancelButton';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import GochiMenuAddGroupV2 from './GochiMenuAddGroupV2';
import SubmitButton from '../../components/atoms/SubmitButton';

const styles = theme => ({
  root: {
    position: 'absolute',
    width: '100%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 30,
    overflow: 'auto',
    outline: 'none',
    [theme.breakpoints.down('sm')]: {
      width: '95%',
      padding: 16
    }
  },
  pageTitle: {
    margin: '32px 0px',
    paddingLeft: 16,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      marginBottom: 10
    }
  },
  editTable: {
    width: 'auto',
    [theme.breakpoints.down('sm')]: {
      display: 'block'
    },
    '& tr': {
      [theme.breakpoints.down('sm')]: {
        display: 'block'
      }
    }
  },
  textField: {
    // padding: '0px 5px 0px 5px',
    minWidth: '300px',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  modal: {
    maxWidth: 1153,
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  title: {
    fontWeight: 700,
    fontSize: 24
  },
  buttonsContainer: {
    margin: '32px 15px 36px'
  },
  borderNone: {
    border: 'none'
  },
  labelControl: {
    marginTop: 16,
    fontSize: 14,
    fontWeight: 400
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      // account: state.accounts.account,
      name: state.loginInfo.name,
      detail: state.gochiMenus.detail,
      shops: state.shops.shops,
      // shops: state.options.listShops,
      groups: state.options.listGroups,
      taxTypes: state.gochiMenus.taxTypes,
      reducedTaxMenuPrefix: state.commons.reducedTaxMenuPrefix,
      account: state.accounts.account
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getMenuImageSample,
          getOptionGroups,
          getOptionShops
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openAdd', 'updateOpenAdd', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'setLoading', false),
  withState('message', 'setMessage', ''),
  withState('errorMessage', 'setErrorMessage', ''),
  withState('usageType', 'setUsageType', usageTypes[0].id),
  withState('menuChildType', 'setMenuChildType', 4),
  withState('shops', 'setShops', []),
  withState('groups', 'setGroups', []),
  withState('shopIdAdd', 'setShopIdAdd', 0),
  withState('shopNameError', 'setShopNameError', ''),
  withState('shopGochiRestriction', 'setShopGochiRestriction', ''),
  withState('shopName', 'setShopName', ''),
  withState('menuImageSampleList', 'setMenuImageSampleList', []),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.actions.getOptionGroups().then(data => {
        this.props.checkSession(data);
        this.props.setGroups(data.payload.list);
      });
      this.props.actions.getOptionShops().then(data => {
        this.props.checkSession(data);
        this.props.setShops(data.payload.list);
      });
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    openAdd,
    updateOpenAdd,
    message,
    setMessage,
    openProgress,
    updateOpenProgress,
    loading,
    setLoading,
    errorMessage,
    setErrorMessage,
    usageType,
    setUsageType,
    menuChildType,
    setMenuChildType,
    shops,
    shopIdAdd,
    setShopIdAdd,
    shopNameError,
    setShopNameError,
    updateOpenAddChooseUsageType,
    shopName,
    setShopName,
    shopGochiRestriction,
    setShopGochiRestriction,
    groups,
    menuImageSampleList,
    setMenuImageSampleList,
    menuGenre,
    onAddGochiMenuSuccess
  }) => {
    const USAGE_TYPE_MENU = usageTypes[0];
    const USAGE_TYPE_VOUCHER = usageTypes[1];
    const USAGE_TYPE_COMBO = usageTypes[2];

    const process = {
      message,
      setMessage,
      openProgress,
      updateOpenProgress,
      loading,
      setLoading,
      errorMessage,
      setErrorMessage
    };

    const getShopOptions = () => {
      const shopOptions = [];
      const tmpObj = { label: '', value: '0', restriction: '' };
      shops.forEach(shop => {
        shopOptions.push({
          label: shop.shopName,
          value: String(shop.shopId),
          restriction: shop.gochiRestriction
        });
      });
      return shopOptions.length > 0 ? { ...shopOptions, tmpObj } : shopOptions;
    };

    const validShopName = () => {
      const value = shopIdAdd;
      if (menuChildType !== 4 && value === 0) {
        setShopNameError('必須項目です。');
        return 1;
      }
      setShopNameError('');
      setShopIdAdd(value);
      return 0;
    };

    const cancelAction = () => updateOpenAddChooseUsageType(false);

    const handleOpenAddMenu = async () => {
      if (validShopName() === 0) {
        updateOpenProgress(true);
        setLoading(true);
        if (usageType === USAGE_TYPE_MENU.id) {
          const response = await actions.getMenuImageSample();
          if (response.type === GET_MENU_IMAGE_SUCCESS) {
            setMenuImageSampleList(response.payload);
          } else {
            setMenuImageSampleList([]);
          }
        } else {
          setMenuImageSampleList([]);
        }
        updateOpenAdd(true);
        updateOpenProgress(false);
        setLoading(false);
      }
    };

    const ref = useRef();

    const progressOkAction = () => {
      onAddGochiMenuSuccess();
      updateOpenProgress(false);
      setMessage('');
      updateOpenAddChooseUsageType(false);
      updateOpenAdd(false);
    };

    return (
      <>
        <div className={classes.root}>
          <div className={classes.pageTitle}>
            <Typography className={classes.title}>
              メニュー追加（1/2）
            </Typography>
          </div>

          <Table className={classes.editTable}>
            <TableBody>
              <TableRow>
                <TableCell className={classes.borderNone} colSpan="2">
                  <Typography>
                    <RequiredButton />
                  </Typography>
                  <Typography component="div" className={classes.labelControl}>
                    用途
                  </Typography>
                  <div>
                    <RadioGroup
                      row
                      value={usageType}
                      onChange={e => {
                        setUsageType(e.target.value);
                      }}
                      style={{ flexWrap: 'nowrap' }}
                    >
                      <div>
                        <FormControlLabel
                          value={USAGE_TYPE_MENU.id}
                          control={<Radio color="primary" />}
                          label={USAGE_TYPE_MENU.name}
                        />
                        <div className={classes.noteText}>
                          メニュー毎に販売（例：日替りランチ、○○弁当など）
                        </div>
                      </div>
                      <div style={{ marginLeft: 16 }}>
                        <FormControlLabel
                          value={USAGE_TYPE_VOUCHER.id}
                          control={<Radio color="primary" />}
                          label={USAGE_TYPE_VOUCHER.name}
                        />
                        <div className={classes.noteText}>
                          金額を決めて販売（例：500円券、1,000円券など）
                        </div>
                      </div>
                      <div style={{ marginLeft: 16 }}>
                        <FormControlLabel
                          value={USAGE_TYPE_COMBO.id}
                          control={<Radio color="primary" />}
                          label={USAGE_TYPE_COMBO.name}
                        />
                        <div className={classes.noteText}>
                          複数枚をセットで販売（例：５回分の価格で６回使える、など）
                        </div>
                      </div>
                    </RadioGroup>
                  </div>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.borderNone} colSpan="2">
                  <Typography>
                    <RequiredButton />
                  </Typography>
                  <Typography component="div" className={classes.labelControl}>
                    対象
                  </Typography>
                  <div>
                    <RadioGroup
                      row
                      value={menuChildType}
                      onChange={e => {
                        const tempChildType = parseInt(e.target.value, 10);
                        setMenuChildType(tempChildType);
                        if (tempChildType === 4) {
                          setShopIdAdd(0);
                          setShopName('');
                          setShopGochiRestriction('');
                        }
                      }}
                    >
                      <FormControlLabel
                        value={4}
                        control={<Radio color="primary" />}
                        label="グループ全体"
                      />
                      <FormControlLabel
                        value={1}
                        control={<Radio color="primary" />}
                        label="店舗指定"
                      />
                    </RadioGroup>
                  </div>
                </TableCell>
              </TableRow>
              {menuChildType !== 4 && (
                <TableRow>
                  <TableCell className={classes.borderNone} colSpan="2">
                    <Typography>
                      <RequiredButton />
                    </Typography>
                    <div>
                      <Typography
                        component="div"
                        className={classes.labelControl}
                      >
                        店舗名*
                      </Typography>
                      <ReactSelectMaterialUi
                        required
                        className={classes.textField}
                        value={String(shopIdAdd)}
                        options={getShopOptions()}
                        onChange={(v, r) => {
                          setShopIdAdd(Number(v));
                          setShopGochiRestriction((r && r.restriction) || '');
                          setShopName((r && r.label) || '');
                        }}
                        SelectProps={{
                          isClearable: true,
                          msgNoOptionsMatchFilter:
                            '名前が部分一致する店舗がありません'
                        }}
                        onBlur={validShopName}
                      />
                      <ValidationText message={shopNameError} />
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          <div className={classes.buttonsContainer}>
            <CancelButton onClickAction={cancelAction} color="primary" />
            <SubmitButton onClickAction={handleOpenAddMenu} btnText="次へ" />
          </div>
        </div>

        <div ref={ref}>
          <Modal open={openAdd} className={classes.modal}>
            <GochiMenuAddGroupV2
              updateOpenAdd={updateOpenAdd}
              onAddGochiMenuSuccess={onAddGochiMenuSuccess}
              menuGenre={menuGenre}
              menuImageSampleList={menuImageSampleList}
              shopGochiRestriction={shopGochiRestriction}
              processBox={process}
              usageType={usageType}
              menuChildType={menuChildType}
              shopName={shopName}
              groups={groups}
              shopId={shopIdAdd}
              shops={shops}
            />
          </Modal>
        </div>

        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={message}
        />

        <ProgressDialog
          openProgress={errorMessage !== ''}
          progressOkAction={() => setErrorMessage('')}
          loading={false}
          resultMessage={errorMessage}
        />
      </>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
